<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
  <div class="compact-register-wrapper">
    <div class="sticky">
      <div class="compact-register-header flex-container">
        <div>
          <div class="entity-name-header">{{ pluralName }}</div>
          @if (totalCount !== null) {
            <mat-chip class="list-count">{{ totalCount | number }}</mat-chip>
          }
        </div>
        @if (showCreate) {
          <button
            class="create-btn"
            type="button"
            mat-button
            color="primary"
            (click)="onCreate()"
            title="Create {{ name }}"
            >
            <mat-icon matListIcon color="primary">add</mat-icon>
            <span>Add {{ name }}</span>
          </button>
        }
      </div>
      <mat-form-field class="search-bar">
        <input
          autocomplete="off"
          type="text"
          #search
          matInput
          [ngModel]="searchText"
          (ngModelChange)="onSearchTextChange($event)"
          placeholder="Search {{ pluralName }}"
          name="search-input"
          />
          <mat-icon matSuffix class="list-search-icon">search</mat-icon>
        </mat-form-field>
      </div>
      <div class="table-wrapper" cdkScrollable>
        <div class="table-display">
          <ng-content></ng-content>
        </div>
        <lcs-table-footer
          class="table-footer"
          [callState]="callState"
          [pagingCallState]="pagingCallState"
          [itemCount]="totalCount"
          [hasNextPage]="hasNextPage"
          (loadMore)="onLoadMore()"
          >
          No {{ name | lowercase }}s found.
        </lcs-table-footer>
      </div>
    </div>
  </lcs-loading-overlay>
